import type { ParseKeys } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar } from '@/components/Icons/Calendar';
import { Pencil } from '@/components/Icons/Pencil';
import {
  AbsenceExcuseType,
  type AbsenceExcuse,
} from '@/pages/Overview/hooks/useAbsenceExcuses';
import { formatDateRange, formatDateTime } from '@/utils/date';

interface Props {
  excuse: AbsenceExcuse;
}

const typeLabelKeys: Record<AbsenceExcuseType, ParseKeys> = {
  [AbsenceExcuseType.Sickness]: 'overview.attendance.excuseType.sickness',
  [AbsenceExcuseType.Other]: 'overview.attendance.excuseType.other',
  [AbsenceExcuseType.Unjustified]: 'overview.attendance.excuseType.unjustified',
};

export const ExcuseCard: React.FC<Props> = ({ excuse }) => {
  const { t } = useTranslation();
  const periodText = formatDateRange(excuse.period.from, excuse.period.to);

  return (
    <div className="flex flex-col gap-3 rounded-xl bg-popover p-4 shadow-card">
      <div className="flex items-center justify-between gap-3">
        <span className="text-subhead-14 truncate text-foreground">
          {excuse.authorName}
        </span>
        <span className="text-body-14 shrink-0 text-subtle-foreground">
          {formatDateTime(excuse.timeCreated)}
        </span>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-1 text-subtle-foreground">
          <Calendar className="size-4 shrink-0" />
          <span className="text-body-13">{periodText}</span>
        </div>
        <div className="flex items-center gap-1 text-subtle-foreground">
          <Pencil className="size-4 shrink-0" />
          <span className="text-body-13">{t(typeLabelKeys[excuse.type])}</span>
        </div>
      </div>
    </div>
  );
};
